import { NgModule } from '@angular/core';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { ListEntitiesModule } from '@epicuro-next/state/list-entities';
import { LookbookEntitiesModule } from '@epicuro-next/state/lookbook-entities';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SHOP_THE_LOOK_FEATURE_KEY } from './constants';
import { ShopTheLookCoreEffects } from './core/shop-the-look-core.effects';
import { ShopTheLookTrackingEffects } from './core/shop-the-look-tracking.effects';
import { CreateShopTheLookEffects } from './create/create-shop-the-look.effects';
import { EditShopTheLookEffects } from './edit/edit-shop-the-look.effects';
import { reducers } from './main-reducer';
import { NewsFeedShopTheLookEffects } from './news-feed/news-feed.effects';
import { ShopTheLooksEffects } from './shop-the-looks/shop-the-looks.effects';

@NgModule({
  imports: [
    DataEngagementApiModule,
    LookbookEntitiesModule,
    ListEntitiesModule,
    DataEngagementApiModule,
    StoreModule.forFeature(SHOP_THE_LOOK_FEATURE_KEY, reducers),
    EffectsModule.forFeature([
      ShopTheLooksEffects,
      EditShopTheLookEffects,
      CreateShopTheLookEffects,
      NewsFeedShopTheLookEffects,
      ShopTheLookCoreEffects,
      ShopTheLookTrackingEffects,
    ]),
  ],
})
export class ShopTheLookStateModule {}
